module.exports = __webpack_public_path__ + "img/sld_scb_29_t1_b1_green.7c055b2b.svg";